<template>
  <div class="content">
    <div id="map_cn"
         class="map_cn"></div>
    <div class="bgc map_but">
      {{mapBut}}
    </div>
  </div>
</template>
 
<script>
import '../utils/hunan.js' //这一步必须引入
import bus from '../utils/bus.js'

export default {
  props: {
    mapBut: {}
  },

  data () {
    return {
      mapId: '',
      myChart: null,
      //地图中的数据
      dataList: [],
      //指定图表的配置项和数据
      option: {
        // 注释部分是图的标题，按需要进行修改
        // title: {
        //   text: '各区域设备分布情况',
        //   subtext: '',
        //   padding: [15, 15],
        //   textStyle: {
        //     fontFamily: '宋体',
        //     fontSize: 16,
        //     fontWeight: 'normal',
        //     color: '#55aaff'
        //   }
        // },
        tooltip: {
          show: true,
          //触发类型：数据项图形触发

          position: 'left',
          trigger: 'item',
          padding: 10,
          borderWidth: 1,
          borderColor: '#409eff',
          backgroundColor: 'rgba(255,255,255,0.8)',
          textStyle: {
            color: '#000000',
            fontSize: 12
          },
          formatter: function (params) {
            var res = ''
            res += '<div>' + params.name + ' </div>'
            res += '<div>' + '县：' + ':' + params.data.aData + '个' + '</div>'
            res += '<div>' + '乡/镇/社区：' + ':' + params.data.bData + '个' + '</div>'
            res += '<div>' + '村：' + ':' + params.data.cData + '个' + '</div>'
            return res
          },
        },
        series: [
          {
            map: '湖南',
            type: 'map',
            aspectScale: 0.9,
            roam: false,
            label: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 12,
              }
            },
            itemStyle: {

              normal: {
                // 图形的描边颜色
                borderColor: '#55aaff',
                // 描边线宽。
                borderWidth: 2,
                // 柱条的描边类型。
                borderType: 'solid',
                // 图形的颜色 #233F53
                areaColor: '#f1f1f1',
                // 图形阴影的模糊大小。
                shadowBlur: 5,
                // 阴影色 #233F53
                shadowColor: '#cecece',
                // X轴阴影
                shadowOffsetX: 5,
                // Y轴阴影
                shadowOffsetY: 5,
                label: {
                  // 显示省份下面市、州的名称
                  show: true,
                  textStyle: {
                    color: '#000000',
                    fontSize: 10,
                  },
                }
              },
              // 鼠标放上去后，样式改变
              emphasis: {
                // 图形的描边颜色
                borderColor: '#2378f7',
                borderWidth: '1',
                // 阴影色
                areaColor: '#55aaff',
                label: {
                  show: true,
                  textStyle: {
                    color: '#000000',
                    fontSize: 10,
                  }
                }
              },
              effect: {
                show: true,
                shadowBlur: 10,
                loop: true,
              }
            },
            select: { // 地图选中区域样式
              label: { // 选中区域的label(文字)样式
                color: 'rgba(0, 0, 0)'
              },
              itemStyle: {// 选中区域的默认样式
                areaColor: 'rgba(255, 255, 255, 1)'
              },
            },
            data: this.dataList,
            layoutCenter: ["50%", "48%", "0", "0"], // 距离左右，上下距离的百分比
            layoutSize: "100%", // map百分比大小
          }
        ],
      },

    };
  },
  mounted () {
    this.getShenList()
  },
  methods: {
    getShenList () {
        var date = JSON.parse(localStorage.getItem("date"))
        this.dataList = date.map(element => {
          var a = element.slist.map(function (elem) {
            return elem.region_burg;
          });
          // console.log(a.join("、"));
          a = a.join("、")
          var cData = 0
          var bData = 0
          var aData = 0
          for (let i = 0; i < a.length; i++)
          {
            if (a[i] === '村')
            {
              cData++
            }
            if (a[i] === '乡' || a[i] === '镇' || a[i] === '社区')
            {
              bData++
            }
            if (a[i] === '县' || a[i] === '市')
            {
              aData++
            }
          }
          return { name: element.region, aData: aData, bData: bData, cData: cData, }
        })
        console.log(this.dataList);
        this.setEchartOption();
        this.$nextTick(() => {
          this.draw_map();
        });
    },

    //定义方法 draw_map 绘制中国地图
    draw_map () {
      this.myChart = this.$echarts.init(document.getElementById('map_cn'));
      //高亮轮播展示
      var hourIndex = 0;
      var carouselTime = null;
      //setInterval() 可在每隔指定的毫秒数循环调用函数或表达式,直到clearInterval把它清除

      //使用setInterval方法后,必须使用箭头函数而不能写function,否则后续在该方法中无法调用data中的数据
      //carouselTime =setInterval(function(){ //错误写法

      carouselTime = setInterval(() => {
        //dispatchAction echarts的API：触发图表行为
        this.myChart.dispatchAction({
          type: "downplay", //downplay 取消高亮指定的数据图形
          seriesIndex: 0
        });
        this.myChart.dispatchAction({
          type: "highlight", //highLight 高亮指定的数据图形
          seriesIndex: 0, //系列index
          dataIndex: hourIndex //数据index
        });
        this.myChart.dispatchAction({
          type: "showTip", //showTip 显示提示框
          seriesIndex: 0,
          dataIndex: hourIndex
        });
        hourIndex++;
        //当循环到数组当中的最后一条数据后，重新进行循环
        if (hourIndex > this.dataList.length)
        {
          hourIndex = 0;
        }
      }, 3000);
      //鼠标移入组件时停止轮播
      this.myChart.on("mousemove", (e) => {
        clearInterval(carouselTime); //清除循环
        this.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        this.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex
        });
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: e.dataIndex
        });
      });
      //鼠标移出组件时恢复轮播
      this.myChart.on("mouseout", () => {
        carouselTime = setInterval(() => {
          this.myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,

          });
          this.myChart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: hourIndex
          });
          this.myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: hourIndex
          });
          hourIndex++;
          if (hourIndex > this.dataList.length)
          {
            hourIndex = 0;
          }
        }, 5000);
      });

      bus.$on('mapBus', (mapId) => {
        console.log(mapId) //componentA参数
        this.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
        });
        this.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: mapId
        });
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: mapId
        });
      })

      //显示地图
      this.myChart.setOption(this.option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    //修改echart配制
    setEchartOption () {
      this.option.series[0].data = this.dataList;
    },

  },
  // created () {
  //   this.setEchartOption();
  // },

};
</script>
 
<style scoped lang="less">
.content {
  position: relative;
  // margin: 0 0 0 -3%;
  width: 100%;
  height: 100%;
  .map_cn {
    width: 100%;
    height: 100%;
    z-index: 1;
    // background: url(../assets/imgs/map/旅游.png) no-repeat;
    // background-size: 100% 100%;
    // background-attachment: fixed;
  }
  .map_but {
    position: absolute;
    right: 8%;
    bottom: 0;
    color: #333;
    font-weight: 900;
    border-radius: 5px;
    cursor: pointer;
    z-index: 10;
  }
  .map_but:hover {
    color: rgb(30, 116, 255);
  }
}
</style>